import {connect} from 'react-redux';

import {
  makeGetCommentAuthor,
  makeGetCommentBeingRepliedTo,
} from '../../../../../srcCommon/inboxes/commentComposer/referencedActivitySelectors';
import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getAllAliases} from '../../../../store/data/teammates/mentionTeammatesSelectors';
import {getUserId} from '../../../../store/data/teammates/teammatesSelectors';
import {getHasQuoteComment} from '../../../../store/featureFlags/featureFlagsSelectors';
import {CommentComposerReplyPreview} from './commentComposerReplyPreview';

/*
 * Props.
 */

interface CommentComposerReplyPreviewContainerPublicProps {
  referencedActivityId?: number;
}

/*
 * Selectors.
 */

function getReferencedActivityId(_state: AppState, props: CommentComposerReplyPreviewContainerPublicProps) {
  return props.referencedActivityId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentComposerReplyPreviewContainerPublicProps>()(() => {
  const getCommentBeingRepliedTo = makeGetCommentBeingRepliedTo(getReferencedActivityId);

  return {
    commentBeingRepliedTo: getCommentBeingRepliedTo,
    authorBeingRepliedTo: makeGetCommentAuthor(getCommentBeingRepliedTo),
    hasQuoteComment: getHasQuoteComment,
    userId: getUserId,
    aliases: getAllAliases,
  };
});

export const CommentComposerReplyPreviewContainer = connect(mapStateToProps)(CommentComposerReplyPreview);
